<template>
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12">
      <slot></slot>
    </div>
  </div>
</template>
